import { ContentContainer } from "@Components/forecast/ContentContainer";
import { LocationDisplay } from "@Components/forecast/location/LocationDisplay";
import WeatherWarning from "@Components/forecast/location/WeatherWarning";

const LocationContainer = () => {
  return (
    <ContentContainer>
      <div className="m:mb-4 m:flex m:flex-col m:justify-between m:gap-4 m:md:mb-10 m:md:flex-row m:md:gap-6 m:md:px-8 m:xl:px-10">
        <LocationDisplay />
        <WeatherWarning />
      </div>
    </ContentContainer>
  );
};

export default LocationContainer;
